import { render, staticRenderFns } from "./AssociateDocument.vue?vue&type=template&id=b6dc1d22"
import script from "./AssociateDocument.vue?vue&type=script&lang=js"
export * from "./AssociateDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports